import { env } from '@/main/config'
import type { RegisterTabCloseRevoke } from '@/modules/auth/use-cases'
import { registerTabCloseRevoke } from '@/shared/infra/impersonation'
import { makeSupabaseClient } from '@/shared/infra/supabase'

export function makeRegisterTabCloseRevoke(): RegisterTabCloseRevoke {
  return () => {
    const supabase = makeSupabaseClient()
    const getToken = async () =>
      (await supabase.auth.getSession()).data.session?.access_token ?? null
    const revokeUrl = `${env.edgeFunctionsBaseUrl}/internal-admin/impersonation/revoke`
    return registerTabCloseRevoke({ getToken, revokeUrl })
  }
}
